<template>
  <div class="button-container">
    <slot name="above-button" />
    <Button
      ref="button"
      :isDisabled="isDisabled"
      :isHidingButtonText="isHidingButtonText"
      :isInactive="isInactive"
      :isSubmitting="isSubmitting"
      :color="buttonColour"
      :height="buttonHeight"
      type="submit"
      :class="buttonClass"
      class="button-container__button"
      v-on="$listeners"
      v-data-test-id="'button-container__button'"
    >
      <slot name="button-content">{{ buttonText }}</slot>
    </Button>
  </div>
</template>

<script>
import Button, { BUTTON_STYLES } from '@/components/_shared/Button.vue'

export default {
  name: 'ButtonContainer',
  components: {
    Button,
  },

  props: {
    buttonText: {
      type: String,
    },
    isHidingButtonText: {
      type: Boolean,
      default: false,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isInactive: {
      type: Boolean,
      default: false,
    },
    buttonColour: {
      type: String,
      default: BUTTON_STYLES.color.black,
      validator(value) {
        return Object.values(BUTTON_STYLES.color).includes(value)
      },
    },
    buttonClass: {
      type: String,
    },
    buttonHeight: {
      type: String,
    },
  },

  methods: {
    getButtonRef() {
      return this.$refs.button
    },

    getButtonEl() {
      return this.getButtonRef().getButtonEl()
    },

    focus() {
      this.getButtonRef().focus()
    },
  },
}
</script>

<style scoped lang="scss">
@import './form-settings.scss';

.button-container {
  @include button-container-margin;
  width: 100%;
}
</style>
